<template>
  <div>
    <span v-for="(route, index) in menu" :key="index">
      <router-link :to="{name:route.routeName}" class="nav-link py-0">
        <b-icon :icon="route.icon" class="rounded bg-light p-1" variant="dark"/>
      </router-link>
    </span>
  </div>
</template>

<script>
import { secondary } from '../nav'

export default {
  data () {
    return {
      menu: secondary
    }
  }
}
</script>
